import styled from "styled-components";

export const Obs = styled.span `
    color: #808080;
    text-transform: uppercase;
    font-weight: bold;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 30px 0px 20px 0px;
`

export const SuggestionContainer = styled.div `
    cursor: pointer;
    background-color: white;
    height: 100px;
    overflow-y: scroll;
    padding-left: 13px;
    position: absolute;
    width: 100%;
    margin-top: 40px;
`

export const Plate = styled.div`
    :hover {
        color: white;
        background-color: #095AA5;
    }
`